import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from '@mui/material';

import AssignmentWizard from "./AssignmentWizard";
import LinkTableCell from "./LinkTableCell";
import { formatDay, formatHumanTime } from "./helpers";
import useSortHead from './useSortHead';

const ClassAssignmentsTable = ({ fetchClassData, className, classData }) => {

    const { TableCellSortHead, sortFunction } = useSortHead();

    const [assignmentWizardOpen, setAssignmentWizardOpen] = useState(false);
    const [editAssignment, setEditAssignment] = useState(null);

    const createOrEditAssignment = (assignment) => {
        setAssignmentWizardOpen(true);
        setEditAssignment(assignment);
    };

    const handleClose = (modified) => {
        setAssignmentWizardOpen(false);
        if (modified) {
            fetchClassData();
        }
    };

    const sortedAssignments = (classData?.assignments ? classData.assignments : []).map((assignment) => {
        const task = assignment.tasks[0];
        const task_description = task.type === 'text' ? 'text' : task.minutes > 0 ? task.minutes + ' min' : task.words + ' words';
        return {...assignment, task_description};
    }).sort(sortFunction);

    return (
        <>
            <div className="add-row-button">
                <Button
                    variant="text"
                    color="primary"
                    onClick={() => createOrEditAssignment(null)}
                >
                    + Add Assignment
                </Button>
            </div>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCellSortHead field='due_date'>Due date</TableCellSortHead>
                        <TableCell>Task</TableCell>
                        <TableCell>Instructions</TableCell>
                        <TableCellSortHead field='expected_study_time'>Minimum expected time</TableCellSortHead>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedAssignments.map(assignment => (
                        <TableRow
                            key={assignment.uuid}
                        >
                            <LinkTableCell onClick={() => createOrEditAssignment(assignment)}>{formatDay(assignment.due_date)}</LinkTableCell>
                            <TableCell>{assignment.task_description}</TableCell>
                            <TableCell><span className="truncate" title={assignment.instructions}>{assignment.instructions}</span></TableCell>
                            <TableCell>{formatHumanTime(assignment.expected_study_time)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <AssignmentWizard open={assignmentWizardOpen} onClose={handleClose} classUUID={classData.uuid} assignment={editAssignment} />
        </>
    );
};

export default ClassAssignmentsTable;
